import LikeableType from "types/LikeableType";
import LoggedOutLikeButton from "./LoggedOutLikeButton";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import LoggedInLikeButton from "./LoggedInLikeButton";

export interface Props {
  likeable: LikeableType;
  showLikes?: boolean;
}

export default function LikeButton({ likeable, showLikes = true }) {
  const currentUserId = useCurrentUserId();

  if (!currentUserId) {
    return <LoggedOutLikeButton showLikes={showLikes} likeable={likeable} />;
  }

  return (
    <LoggedInLikeButton
      showLikes={showLikes}
      likeable={likeable}
    />
  );
}
